jQuery(document).ready(function ($) {

	

	// setTimeout (function () {
	// 	var wb = $('#woof_html_buffer');
	// 	var lw = $('.loader-wrap .loader');
	// 	wb.prepend(lw[0]);
	// }, 500);


	// $('button#place_order[type="submit"]').click( function(e) {
	// 	e.preventDefault();
	// 	e.stopProoagation();
	// 	console.log("click submit");
	// });


	// var $flags = $('[name="dgwt_wcas"]');
	// if($flags.length) $flags.remove();

	// var parentLink = $('#header-nav .product-cat-menu-parent');
	// var subMenu = $('#sub-menu-wrap');

	// var pos = parentLink.offset();
	// console.log("Top: " + pos.top + " Left: " + pos.left);

	// var styles = {
	// 	top: pos.top + 40,
	// 	left: pos.left,
	// };

	// subMenu.css(styles);

	// parentLink.hover(function () {
	// 	subMenu.addClass('open');
	// });

	// $(document).on("click.filterOpen", function (e) {
	// 	if (!subMenu.is(e.target) && subMenu.has(e.target).length === 0) {
	// 		subMenu.removeClass("open");
	// 	}
	// });

	// $(".filter-title").click(function () {
	// 	let filter = $(this).parents('.filter');
	// 	filter.toggleClass("filter-open");
	// 	$(document).on("click.filterOpen", function (e) {
	// 		if (!filter.is(e.target) && filter.has(e.target).length === 0) {
	// 			filter.removeClass("filter-open");
	// 		}
	// 	});
	// });
	$(document).on('click', '#burger-mobile-menu', function () {
		$('#mobile-menu-wrap').toggleClass('open');
		$('body').toggleClass('noScroll');
		return false;
	});

	$('#mobile-filter-btn').click(function () {
		$('#secondary.widget-area').toggleClass('open');
		$(this).toggleClass('open');
	});

	$('.woof_open_hidden_li_btn').click(function () {
		$(this).toggleClass('open');
	});

	$('.woof_section_scrolled').each(function (index) {
		var elem = $(this).find('.woof_open_hidden_li_btn');
		var elClass = 'p_open_hidden_li_btn_' + index;
		var elemText = elem.html();
		elem.hide();

		let div = document.createElement('DIV');
		div.classList.add(elClass);
		div.classList.add("p_open_hidden_li_btn");
		div.innerHTML = elemText;
		div.addEventListener('click', function () {
			elem.click();
			$(this).toggleClass('open');
		});
		$(this).after(div);

		setTimeout(() => {
			if ($(this).parent().height() >= 400) {
				div.classList.toggle('open');
			}
		}, 300);
	});
	// if (!$('body').hasClass('woocommerce-cart') && !$('body').hasClass('woocommerce-checkout')) {
	// 	var mcWrap = $('#minicart-wrap');
	// 	$('.cart-wrap').click(function () {
	// 		console.log("click");
	// 		// var wrap = $('#minicart-wrap');
	// 		if (mcWrap.hasClass('open')) {
	// 			console.log("remove");
	// 			//				$('body').click();
	// 			mcWrap.removeClass('open');
	// 			$(this).removeClass('open');
	// 		} else {
	// 			console.log("add");
	// 			mcWrap.addClass('open');
	// 			$(this).addClass('open');
	// 		}
	// 	});
	// }

	$('#site-header-cart, #minicart-wrap').hover(
		function() {
			$('#minicart-wrap').addClass('open');
			$('.cart-wrap').addClass('open');
		},
		function() {
			$('#minicart-wrap').removeClass('open');
			$('.cart-wrap').removeClass('open');
		}
	);

	// $(document).mouseup(function (e) { // событие клика по веб-документу

	// 	var mcWrap = $("#minicart-wrap"); // тут указываем ID элемента
	// 	var mcIco = $('.cart-wrap');

	// 	if (
	// 		!mcIco.hasClass('open') &&
	// 		(mcIco.is(e.target) || mcIco.has(e.target).length !== 0)
	// 	) {
	// 		mcWrap.addClass('open');
	// 		mcIco.addClass('open');

	// 	} else if (
	// 		!mcWrap.is(e.target) // если клик был не по нашему блоку
	// 		&& mcWrap.has(e.target).length === 0 // и не по его дочерним элементам
	// 	) {
	// 		mcWrap.removeClass('open'); // скрываем его
	// 		mcIco.removeClass('open');
	// 	}
	// });

	// $( "select" )
	//   .change(function () {
	//     var str = "";
	//     $( "select option:selected" ).each(function() {
	//       str += $( this ).text() + " ";
	//     });
	//     $( "div" ).text( str );
	// }).change();

	// function setHref ( val ) {
	// 	console.log(val);
	// }

	$('.woof_submit_search_form').click(function () {
		$('.loader-wrap').show();
	})

	$(document).on("woof_ajax_done", function (e) {
		$('.loader-wrap').hide();
	});

	$(document.body).on('added_to_cart', function () {
		$('#add-to-cart-mess')[0].click();
	});

	$('#sf-shipping-method-select').on('change', function () {
		$('#' + $(this).val()).click();
	});

	$(document).on('change', '.custom_payment_methods select[name="mrkv_monopay_extend_pro_months"]', function() {
		var val = $(this).val();
		console.log(val);

		$('select[name="mrkv_monopay_extend_pro_months"]').each(function() {
			$(this).find('option[value="'+ val +'"]').prop('selected', true);
		});
	});

	$('#filter-toogle-btn').click(function () {
		$('.home-filter-wrap').toggleClass('open');
		$(this).toggleClass('open');
	});

	function formatOption(option) {
		var $option = $(
			'<div class="sf-option-title">' + option.text + '</div><div class="sf-option-desc">' + option.title + '</div>'
		);
		return $option;
	};

	if ($('body').hasClass('woocommerce-checkout')) {

		// $("#sf-payment-method-select").select2({
		// 	placeholder: 'Спосіб оплати',
		// 	templateResult: formatOption,
		// 	minimumResultsForSearch: -1,
		// });

		$('.custom_payment_methods label').click(function () {
			let id = $(this).attr('for');

			$('.custom_payment_methods .payment_method').removeClass('active');
			$(this).closest('.payment_method').addClass('active');
		});

		var bodyEl = $('body.woocommerce-checkout');
		$("#sf-shipping-method-select").select2({
			placeholder: 'Спосіб доставки',
			minimumResultsForSearch: -1,
		}).on('select2:select', function (e) {
			if (e.params.data.id == 'shipping_method_0_local_pickup-8')
				bodyEl.addClass('pickup');
			else
				bodyEl.removeClass('pickup');

			$('.custom_payment_methods input').attr('checked', false);
			// $("#sf-payment-method-select").val(null).trigger("change");
		});
	};

	/* 
		// get pay methods list
		if ($('body').hasClass('woocommerce-checkout')) {
			var pmList;
			var selElem = $("#sf-payment-method-select");
		
			$.ajax({
				url: ajaxurl,
				data: { action: 'get_payment_method_list' },
				type: 'POST',
				success: function (data) {
					pmList = JSON.parse(data);
		
					console.log("ajax");
					console.log(pmList);
					// var newOption = new Option('text', 'cod', false, false);
					// selElem.append(newOption).trigger('change');
					// if (res.is_send) {
					// 	window.location.href = '/shop';
					// }
				}
			});
		
			setTimeout(() => {
				$("#sf-payment-method-select").select2({
					placeholder: 'Спосіб оплати',
					templateResult: formatOption,
					minimumResultsForSearch: -1,
		
					// }).on('select2:select', function (e) {
					// 	var data = e.params.data;
					// 	console.log(data);
				});
		
				function formatOption(option) {
					var $option = $(
						'<div class="sf-option-title">' + option.text + '</div><div class="sf-option-desc">' + option.title + '</div>'
					);
					return $option;
				};
		
				$("#sf-shipping-method-select").select2({
					placeholder: 'Спосіб доставки',
					minimumResultsForSearch: -1,
				}).on('select2:select', function (e) {
					var data = e.params.data;
					console.log(data);
		
					// var newOption = new Option('text', 'cod', false, false);
					if (e.params.data.id == 'shipping_method_0_local_pickup-8') {
						console.log(e.params.data);
						// selElem.empty();
						// selElem.select2('data', null);
		
						selElem.append([{
							"id": "tst",
							"text": "label title",
							"title": "label desc",
							"element": HTMLOptionElement,
						}]).trigger('change');
		
					}
				});
			}, 2000);
		}; */

	$('#sf-payment-method-select').on('change', function () {
		$('#' + $(this).val()).click();
	});

	function getUrlParam(param) {
		var pageUrl = window.location.search.substring(1);
		var paramList = pageUrl.split('&');
		for (var i = 0; i < paramList.length; i++) {
			var paramAttr = paramList[i].split('=');
			if (paramAttr[0] == param) return paramAttr[1];
		}
		return '';
	}

	setTimeout(function () {
		if ($('body').hasClass('woocommerce-shop') && $('#message-flag').hasClass("new-order")) {
			$('#sf-new-order-mess')[0].click();
			$('#message-flag').removeClass("new-order")
		}
	}, 300);

	$("#perpage-select").change(function () {
		console.log($(this).val());
		//$(this).val()
		//http_build_query(array_merge($_GET, $(this).val()))
		window.location.href = $(this).val();
	});

	// update cart after change qty of products
	// $( '.woocommerce-cart-form :input[name="update_cart"]' ).prop( 'disabled', false ).attr( 'aria-disabled', false );
	// var timeout;
	// $('.cart-item-list').on('change', 'input.qty', function(){
	//     console.log("in change");

	//     if ( timeout !== undefined ) clearTimeout( timeout );
	//     timeout = setTimeout(function() {
	//         console.log("in change");
	//         $("#sf-update-cart-btn").trigger('click');
	//     }, 1000 );
	// });

	$('#preorder-submit').click(function () {
		var
			params = {
				action: 'send_preorder',
				order_phone: $('#preorder-phone').val(),
			},
			phoneno = /^[\+]?[0-9]{2}[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}$/im,
			invMessElem = $('#invalid-message');

		if (!params.order_phone.match(phoneno)) {
			invMessElem.show();
			return false;
		}

		invMessElem.hide();
		$('.loader-wrap').show();

		$.ajax({
			url: ajaxurl,
			data: params,
			type: 'POST',
			beforeSend: function (xhr) {
				// $('.preloader').removeClass('hide');
			},
			complete: function () {
				// $('.preloader').addClass('hide');
			},
			success: function (data) {
				let res = JSON.parse(data);
				// console.log(res);
				if (res.is_send) {
					window.location.href = '/shop';
				}
			}
		});
	});

	// $('body').on('blur change', '#billing_last_name', function(){
	// 	var wrapper = $(this).closest('.form-row');
	// 	// you do not have to removeClass() because Woo do it in checkout.js
	// 	if( /\d/.test( $(this).val() ) ) { // check if contains numbers
	// 		wrapper.addClass('woocommerce-invalid'); // error
	// 	} else {
	// 		wrapper.addClass('woocommerce-validated'); // success
	// 	}
	// });

	setTimeout(function () {
		if ($('body').hasClass('woocommerce-shop') && $('#message-flag').hasClass("new-preorder")) {
			$('#preorder-link')[0].click();
			$('#message-flag').removeClass("new-preorder")
		};
	}, 300);

	// home slider
	var hoomeSlider = $('.home-slider');
	if (hoomeSlider.length) {
		hoomeSlider.slick({
			slidesToShow: 1,
			speed: 300,
			infinite: true,
			arrows: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			swipe: true,
			touchMove: true,
			dots: true,
			appendDots: '#dots-area',
			autoplay: true,
			lazyLoad: 'ondemand',
			autoplaySpeed: 5000,
			draggable: false,
			// appendArrows: '.events-slider-nav',
			// prevArrow: '<div class="events-slider-nav__item events-slider-nav__item--prev slider-arrow"><svg class="slider-arrow__icon slider-arrow__icon--prev"><use xlink:href="#left-chevron"></use></svg></div>',
			// nextArrow: '<div class="events-slider-nav__item events-slider-nav__item--next slider-arrow"><svg class="slider-arrow__icon slider-arrow__icon--next"><use xlink:href="#right-chevron"></use></svg></div>',
			// responsive: [
			//     {
			//         breakpoint: 1366,
			//         settings: {
			//             slidesToShow: 3,
			//         }
			//     },
			//     {
			//         breakpoint: 768,
			//         settings: {
			//             slidesToShow: 2,
			//             arrows: false,
			//             swipe: true,
			//             draggable: true,
			//             // pauseOnFocus: true,
			//             // pauseOnHover: true,
			//             // dots: true,
			//             // touchMove: true,
			//             // appendDots: '.events-slider-nav',
			//         }
			//     },
			//     {
			//         breakpoint: 480,
			//         settings: {
			//             slidesToShow: 1,
			//         }
			//     },
			// ]
		});

		$('#dots-area').on('click', function() {
			hoomeSlider.slick('slickPause');
		});

		/*
		// slick progress bar
		var time = 2;
		var $bar,
			$slick,
			isPause,
			tick,
			percentTime;
	 
		$bar = $('.slider-progress .progress');
	 
		$('.slider-wrapper').on({
			mouseenter: function () {
				isPause = true;
			},
			mouseleave: function () {
				isPause = false;
			}
		})
	 
		function startProgressbar() {
			resetProgressbar();
			percentTime = 0;
			isPause = false;
			tick = setInterval(interval, 25);
		}
	 
		function interval() {
			if (isPause === false) {
				percentTime += 1 / (time + 0.025);
				$bar.css({
					width: percentTime + "%"
				});
				if (percentTime >= 100) {
					hoomeSlider.slick('slickNext');
					startProgressbar();
				}
			}
		}
	 
		function resetProgressbar() {
			$bar.css({
				width: 0 + '%'
			});
			clearTimeout(tick);
		}
	 
		startProgressbar();
		*/

		//        console.log(hoomeSlider.slick('slickGetOption', 'autoplaySpeed'));
	};


	var hoomeProductSlider = $('.section-product-slider .woocommerce .products');
	if (hoomeProductSlider.length) {
		hoomeProductSlider.slick({
			slidesToShow: 4,
			speed: 300,
			infinite: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			swipeToSlide: true,
			swipe: true,
			touchMove: true,
			lazyLoad: 'ondemand',
			dots: false,
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: true,
			prevArrow:
				`<div class="slider-arrow prev">
                    <div class="arrow-bg">
                        <svg class="svg-wrap"><use xlink:href="#slider-btn-prev-bg"></use></svg>
                    </div>
                    <div class="arrow-item">
                        <div class="arrow-ico">
                            <svg class="svg-wrap"><use xlink:href="#slider-arrow-prev"></use></svg>
                        </div>
                    </div>
                </div>`,
			nextArrow:
				`<div class="slider-arrow next">
                    <div class="arrow-bg">
                        <svg class="svg-wrap"><use xlink:href="#slider-btn-prev-bg"></use></svg>
                    </div>
                    <div class="arrow-item">
                        <div class="arrow-ico">
                            <svg class="svg-wrap"><use xlink:href="#slider-arrow-next"></use></svg>
                        </div>
                    </div>
                </div>`,
			responsive: [
				{
					breakpoint: 1366,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						// arrows: false,
					}
				},
			]
		});
	};

	//  related products
	var relatedProductSlider = $('.wt-related-products ul.products');
	if (relatedProductSlider.length) {
		relatedProductSlider.slick({
			slidesToShow: 4,
			speed: 300,
			infinite: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			swipeToSlide: true,
			swipe: true,
			touchMove: true,
			dots: false,
			lazyLoad: 'ondemand',
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: true,
			prevArrow:
				`<div class="slider-arrow prev">
                    <div class="arrow-bg">
                        <svg class="svg-wrap"><use xlink:href="#slider-btn-prev-bg"></use></svg>
                    </div>
                    <div class="arrow-item">
                        <div class="arrow-ico">
                            <svg class="svg-wrap"><use xlink:href="#slider-arrow-prev"></use></svg>
                        </div>
                    </div>
                </div>`,
			nextArrow:
				`<div class="slider-arrow next">
                    <div class="arrow-bg">
                        <svg class="svg-wrap"><use xlink:href="#slider-btn-prev-bg"></use></svg>
                    </div>
                    <div class="arrow-item">
                        <div class="arrow-ico">
                            <svg class="svg-wrap"><use xlink:href="#slider-arrow-next"></use></svg>
                        </div>
                    </div>
                </div>`,
			responsive: [
				{
					breakpoint: 1366,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						arrows: false,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						arrows: false,
					}
				},
			]
		});
	};


	
	
	/**
	 * Disable WPCF7 button while it's submitting
	 * Stops duplicate enquiries coming through
	 */

	var cf7_form = $('form.wpcf7-form');
	$(document).on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed wpcf7submit', function (event) {

		// find only disbaled submit buttons
		var button = $('.wpcf7-submit[disabled]');

		// grab the old value
		var old_value = button.attr('data-value');

		// enable the button
		button.prop('disabled', false);

		// put the old value back in
		button.val(old_value);

	});

	cf7_form.on('submit', function () {

		console.log(document.getElementsByTagName('html')[0].getAttribute('lang'));

		var
			form = $(this),
			button = form.find('input[type=submit]'),
			current_val = button.val(),
			currLang = document.getElementsByTagName('html')[0].getAttribute('lang'),
			langList = {
				'en-US': 'Sending...',
				'ru-RU': 'Отправляем...',
				'uk': 'Відправляємо...',
			};

		// store the current value so we can reset it later
		button.attr('data-value', current_val);

		// disable the button
		button.prop("disabled", true);

		// tell the user what's happening
		button.val(langList[currLang]);
	});

	$('#reg_username').on('input', function(){
		if(/[`,',', ,=,+,-,-,),(,*,?,:,%,;,№,",!,₴,/,.,|,~,@,#,$,^,&,},{,>,<,\\,\],\[]/.test($(this).val())){
            let Selection = this.selectionStart-1;
            $(this).val( $(this).val().replace(/[`,',', ,,=,+,-,-,),(,*,?,:,%,;,№,",!,₴,/,.,|,~,@,#,$,^,&,},{,>,<,\\,\],\[]/g,'') );
            this.setSelectionRange(Selection, Selection)
        }
	});

	$(document).on('click', '#mobile-menu-wrap .menu-item-has-children > a', function () {
		$(this).closest('.menu-item').toggleClass('show');
		return false;
	});

});



